// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3SOBc","label":"LabeledBox_label__enCc2"};